<div ngbDropdown class="d-inline-block options-dropdown">
  <button class="btn btn-sm btn-outline-secondary dropdown-button" ngbDropdownToggle>
    {{ buttonName }}
    <i *ngIf="!isAnyOptionsSelected" class="fal fa-filter"></i>
    <i *ngIf="isAnyOptionsSelected" class="fa fa-filter"></i>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
    <ul
      class="column-layout"
      [ngClass]="{ 'multi-column': filterOptions.length > 6 }"
    >
      <li *ngFor="let option of filterOptions">
        <label class="filter-dropdown-label">
          <input
            type="checkbox"
            [value]="option"
            (change)="onOptionChange($event, option)"
            [disabled]="option.isDisabled"
            [checked]="option.isChecked"
            [class]="getDisabledClass(option?.isDisabled)"
            attr.data-dd-action-name="{{ option.name }} Filter Option"
          />
          <span> {{ option.name }}</span>
          <span *ngIf="option.count"> ({{ option.count | number }})</span>
        </label>
      </li>
    </ul>
  </div>
</div>
